import { SeuConfigInputItem } from '@seu-types';

export const SEU_COMPONENT_INPUT_PLACEHOLDER = 'input-0';
export const SEU_COMPONENT_OUTPUT_PLACEHOLDER = 'output-0';

export const SEU_COMPONENT_REZIRCULATION_INPUT_ID = 'rezirculationToggle';

export type SeuComponentHandle = {
  id: string;
};

export type SeuComponentOutputHandleValueBase = {
  unit: string;
  isRemainder: boolean;
  value: number | null;
};

export type SeuComponentOutputHandleValue =
  SeuComponentOutputHandleValueBase & {
    operatingConditionId: string;
  };

export type SeuComponentOutputHandle = SeuComponentHandle & {
  isRezirculation?: boolean;
  values: SeuComponentOutputHandleValue[];
};

export type SeuComponentBase = {
  name: string;
  componentType: string;
  inputs: SeuConfigInputItem[];
  inputHandles: SeuComponentHandle[];
  outputHandles: SeuComponentOutputHandle[];
};

export type SeuComponent = SeuComponentBase & {
  id: string;
};

export type SeuComponentOutputHandleValueApi =
  SeuComponentOutputHandleValueBase & {
    operatingConditionId: number;
  };

export type SeuComponentOutputHandleApi = SeuComponentHandle & {
  values: SeuComponentOutputHandleValueApi[];
};

export type SeuComponentBaseApi = {
  name: string;
  componentType: string;
  inputs: SeuConfigInputItem[];
  inputHandles?: SeuComponentHandle[];
  outputHandles?: SeuComponentOutputHandleApi[];
};

export type SeuComponentApi = SeuComponentBaseApi & {
  id: number;
};

export type SeuComponentLibraryCategory = {
  name: string;
  items: SeuComponentLibraryCategoryItem[];
};

export type SeuComponentLibraryCategoryItem = {
  svg: string;
  label: string;
  componentType: string;
  synonyms: string[];
};
